import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteReference } from './actions';
import { getReferences } from './reducer';
import { hasMutation } from './utils';

class ReferenceList extends Component {
  deleteReference = id => {
    this.props.deleteReference(id, 'cs');
  };

  renderTable = () => {
    const { references } = this.props;

    console.log(references);

    return references.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>{hasCs ? item.header.cs : hasEn ? item.header.en : ''}</td>
          <td>
            <Link
              to={{
                pathname: hasCs
                  ? `/reference/edit/${item.id}/cs`
                  : `/reference/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn
                  ? `/reference/edit/${item.id}/en`
                  : `/reference/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { references } = this.props;

    if (references.length === 0) {
      return <div>Seznam referencí je prázdný</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Reference</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    references: getReferences(state)
  };
};

export default connect(
  mapStateToProps,
  { deleteReference }
)(ReferenceList);



// WEBPACK FOOTER //
// ./src/modules/ReferenceList/index.js